import React, { FC, memo } from 'react';

import { PointsListCheckboxGroupPointType } from 'application/components/PointItemContent/types';

import IconMapPin from '@zvuk-b2b/react-uikit/ui/icons/MapPin';

import styles from './index.module.scss';

interface PointAddressesListProps {
  id: PointsListCheckboxGroupPointType['id'];
  address: PointsListCheckboxGroupPointType['address'];
  title?: PointsListCheckboxGroupPointType['title'];
}

const PointAddressItem: FC<PointAddressesListProps> = ({ id, address, title }) => (
  <div
    key={id}
    className={styles.listRow}>
    <IconMapPin className={styles.listIcon} />
    <span>{address || title}</span>
  </div>
);

export default memo(PointAddressItem);
